import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

/**
 * ref1: https://github.com/google-map-react/google-map-react/blob/HEAD/API.md
 * ref2: https://qiita.com/miyabiya/items/98c8a177e6077ee50971
 */
class GoogleMapView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      maps: null,
      marker: null,
    };
  }

  setMarker() {
    const { lat, lng } = this.props;
    const { map, maps, marker } = this.state;
    if (marker) marker.setMap(null);
    this.setState({ marker: null });
    if (map && maps && lat && lng) {
      const position = { lat, lng };
      const newMarker = new maps.Marker({ position, map });
      this.setState({ marker: newMarker });
    }
  }

  handleGoogleApiLoaded(map, maps) {
    this.setState({ map, maps });
    this.setMarker();
  }

  handleChange() {
    this.setMarker();
  }

  render() {
    const { apps, apiKey, lat, lng, zoom } = this.props;
    const center = { lat, lng };
    const lang = apps.currentLanguage;
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '160px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey, language: lang }}
          language={lang}
          center={center}
          defaultZoom={zoom}
          onGoogleApiLoaded={({ map, maps }) => this.handleGoogleApiLoaded(map, maps)}
          onChange={() => this.handleChange()}
        />
      </div>
    );
  }
}

GoogleMapView.propTypes = {
  apps: PropTypes.objectOf(PropTypes.any).isRequired,
  apiKey: PropTypes.string.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  apps: state.apps,
});

const mapDispatchToProps = {};

const myStyles = () => ({});

export default compose(
  withStyles(myStyles),
  connect(mapStateToProps, mapDispatchToProps),
)(GoogleMapView);
